import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var RotateLeft = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M6.758 8.758L5.344 7.344a8.048 8.048 0 00-1.841 2.859l1.873.701a6.048 6.048 0 011.382-2.146zM19 12.999a7.935 7.935 0 00-2.344-5.655A7.917 7.917 0 0012 5.069V2L7 6l5 4V7.089a5.944 5.944 0 013.242 1.669A5.956 5.956 0 0117 13v.002c0 .33-.033.655-.086.977-.007.043-.011.088-.019.131a6.053 6.053 0 01-1.138 2.536c-.16.209-.331.412-.516.597a5.954 5.954 0 01-.728.613 5.906 5.906 0 01-2.277 1.015c-.142.03-.285.05-.43.069-.062.009-.122.021-.184.027a6.104 6.104 0 01-1.898-.103L9.3 20.819a8.087 8.087 0 002.534.136c.069-.007.138-.021.207-.03.205-.026.409-.056.61-.098l.053-.009-.001-.005a7.877 7.877 0 002.136-.795l.001.001.028-.019a7.906 7.906 0 001.01-.67c.27-.209.532-.43.777-.675.248-.247.47-.513.681-.785.021-.028.049-.053.07-.081l-.006-.004a7.899 7.899 0 001.093-1.997l.008.003c.029-.078.05-.158.076-.237.037-.11.075-.221.107-.333.04-.14.073-.281.105-.423.022-.099.048-.195.066-.295.032-.171.056-.344.076-.516.01-.076.023-.15.03-.227.023-.249.037-.5.037-.753.002-.002.002-.004.002-.008zM6.197 16.597l-1.6 1.201a8.045 8.045 0 002.569 2.225l.961-1.754a6.018 6.018 0 01-1.93-1.672zM5 13c0-.145.005-.287.015-.429l-1.994-.143a7.977 7.977 0 00.483 3.372l1.873-.701A5.975 5.975 0 015 13z",
    key: "k0"
  }));
});
RotateLeft.displayName = 'RotateLeft';
export var RotateLeftDimensions = {
  height: 24,
  width: 24
};